import React, { useEffect, useContext } from 'react'
import jwt_decode from 'jwt-decode'
import { Grid, Paper, Button, Link, Typography, CssBaseline, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import { login, getTokenData } from '../clients/oauth2'
import { ReactComponent as Logo } from '../assets/logo-dark.svg'
import Gif from '../assets/gif.gif'
type Params = {
  error?: string
}

type DecodedJwt = {
  email?: string
}

const Index = (): JSX.Element => {
  const { auth, setAuth } = useContext(AuthContext)
  const { error }: Params = useParams()

  const handleLoginClick = () => {
    login()
  }

  useEffect(() => {
    if (auth.accessToken && auth.idToken) {
      window.location.replace('/monitoramento-diario/detalhe-principal')
    } else if (error) {
      console.error('error', error)
    } else if (window.location.hash) {
      const { idToken, accessToken } = getTokenData(window.location.hash)
      const { email }: DecodedJwt = jwt_decode(idToken)
      setAuth({
        idToken,
        accessToken,
        email
      })
      window.location.hash = ''
      window.location.replace('/monitoramento-diario/detalhe-principal')
    }
  }, [])

  const useStyles = makeStyles((theme) => ({
    root: {
      height: '100vh'
    },
    image: {
      background: `url(${Gif})`,
      backgroundRepeat: 'no-repeat',
      backgroundColor: '#f7f8f8',
      // theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
      backgroundSize: '80%',
      backgroundPosition: 'center'
    },
    paper: {
      margin: theme.spacing(12, 4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    form: {
      width: '100%',
      marginTop: theme.spacing(1)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    welcomeText: {
      marginTop: theme.spacing(8)
    },
    welcomeName: {
      marginTop: theme.spacing(3)
    }
  }))

  function Copyright () {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://www.farmaciasapp.com.br">
          Farmácias app
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    )
  }
  const classes = useStyles()
  return (
    <div>
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={3} square>
          <div className={classes.paper}>
            <Logo />
            <Typography className={classes.welcomeText} component="h3" variant="h2">
              Bem-vindo!
            </Typography>
            <Typography className={classes.welcomeName} component="h4" variant="h5">
              Portal analytics
            </Typography>
            <form className={classes.form}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={() => { handleLoginClick() }}
              >
                Acessar
              </Button>
              <Box mt={5}>
                <Copyright />
              </Box>
            </form>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}

export default Index
